import MediaService from "../services/KangarooServices/MediaServices";

const uploadImageApi = async (formData) => {
  try {
   
    const response = await MediaService.create(formData);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export default uploadImageApi